/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { FROSTKeygen, FROSTKeygenInterface } from "../FROSTKeygen";

const _abi = [
  {
    anonymous: false,
    inputs: [],
    name: "EndedFROSTKeygen",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "StartedFROSTKeygen",
    type: "event",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "startFROSTKeygen",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "endFROSTKeygen",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type FROSTKeygenConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: FROSTKeygenConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class FROSTKeygen__factory extends ContractFactory {
  constructor(...args: FROSTKeygenConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "FROSTKeygen";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<FROSTKeygen> {
    return super.deploy(overrides || {}) as Promise<FROSTKeygen>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): FROSTKeygen {
    return super.attach(address) as FROSTKeygen;
  }
  connect(signer: Signer): FROSTKeygen__factory {
    return super.connect(signer) as FROSTKeygen__factory;
  }
  static readonly contractName: "FROSTKeygen";
  public readonly contractName: "FROSTKeygen";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): FROSTKeygenInterface {
    return new utils.Interface(_abi) as FROSTKeygenInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FROSTKeygen {
    return new Contract(address, _abi, signerOrProvider) as FROSTKeygen;
  }
}
